import '../sass/main.scss';
import 'lazysizes';
import 'jquery';
import {Header} from "./layouts/header";
import {Faq} from "./layouts/faq";
import {onLoadCheckFancyboxMessage} from "./helpers/helpers";
import {toolTip} from "./components/tooltip";
import {validatePhone} from "./components/helpers";
import InitSplide from "./components/splide";
import toggleAccordions from "./components/accordions";

export class Defaults {
    load() {
        new Header();
        new Faq();
        new toolTip();
        onLoadCheckFancyboxMessage();
        InitSplide();
        toggleAccordions();
    }
}

export const defaults = new Defaults();